<template>
    <div>
        <rkm-form
            ref="Form"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-input
                        :validations="validations.nome"
                        label="Nome"
                        uppercase
                        v-model="model.nome"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :validations="validations.departamento"
                        label="Departamento"
                        uppercase
                        v-model="model.departamento"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :validations="validations.cargo"
                        label="Cargo"
                        uppercase
                        v-model="model.cargo"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :validations="validations.telefone"
                        label="Telefone"
                        v-mask="numeroMask"
                        v-model="model.telefone"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-input
                        :validations="validations.email"
                        label="Email"
                        v-model="model.email"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click.stop="$refs.Form.validate(add)"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>
    </div>
</template>

<script>
// Mixins.
import { object, mask } from '@/mixins'

export default {
    computed: {
        validations() {

            return {
                nome: {
                    required: true,
                    min: 6,
                    max: 150,
                },
                departamento: {
                    max: 50,
                },
                cargo: {
                    max: 50,
                },
                telefone: {
                    required: !this.model.email,
                    min_max_without_mask: [10, 11],
                },
                email: {
                    required: !this.model.telefone,
                    max: 180,
                    email: true,
                },
            }
        },
        numeroMask() {

            if (this.model.telefone === '') {

                return ''
            }

            return this.model.telefone.length < 15 ? this.mask.phone : this.mask.cellPhone
        },
    },
    data: () => ({
        model: {
            nome: null,
            departamento: null,
            cargo: null,
            telefone: '',
            email: null,
        },
    }),
    methods: {
        add() {

            this.data.model.contatos.push(this.clone(this.model))

            this.resetForm()
        },
        resetForm() {

            this.model.nome = null
            this.model.departamento = null
            this.model.cargo = null
            this.model.telefone = ''
            this.model.email = null

            this.$refs.Form.resetValidator()
        }
    },
    mixins: [ object, mask ],
    props: {
        data: { type: Object, required: true }
    },
}
</script>